var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#febe1e;}.cls-2{fill:#feaa2e;}.cls-3{fill:#ffd21d;}.cls-4{fill:#fde266;}.cls-5{fill:#ffe27a;}.cls-6{fill:#f9dd7a;}.cls-7{fill:#fff;}.cls-8{fill:#b42625;}.cls-9{fill:#ef2f30;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mindjjo_points",
    "data-name": "mindjjo points"
  }, /*#__PURE__*/React.createElement("g", {
    id: "badge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52786",
    "data-name": "Group 52786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69022-2",
    "data-name": "Path 69022-2",
    className: "cls-1",
    d: "M25,48.37C0,48.37,0,24.23,0,23.85a25,25,0,0,1,49.94,0c0,.38,0,24.52-25,24.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69023",
    "data-name": "Path 69023",
    className: "cls-2",
    d: "M25,47.69A25,25,0,0,1,0,23.85c0,.38,0,.77,0,1.16a25,25,0,0,0,50,0h0c0-.39,0-.78,0-1.16A25,25,0,0,1,25,47.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69024",
    "data-name": "Path 69024",
    className: "cls-3",
    d: "M25,43.54C4.93,43.54,5,24.23,5,23.85a20.06,20.06,0,0,1,40.06,0C45.05,24.23,45,43.54,25,43.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69025",
    "data-name": "Path 69025",
    className: "cls-4",
    d: "M25,42.76A20.07,20.07,0,0,1,5,23.85c0,.38,0,.77,0,1.16a20.07,20.07,0,0,0,40.13,0c0-.39,0-.78,0-1.16A20.07,20.07,0,0,1,25,42.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69026",
    "data-name": "Path 69026",
    className: "cls-5",
    d: "M26.82,15.3l1.85,3.76a2,2,0,0,0,1.53,1.11l4.15.6a2,2,0,0,1,1.12,3.46l-3,2.92a2,2,0,0,0-.58,1.8l.71,4.13a1.93,1.93,0,0,1-.2,1.27H29.65L25,32.05l-4.65,2.3H17.59a2,2,0,0,1-.19-1.27L18.11,29a2,2,0,0,0-.58-1.8l-3-2.92a2,2,0,0,1,0-2.87,2,2,0,0,1,1.16-.59l4.15-.6a2,2,0,0,0,1.52-1.11l1.86-3.76a2,2,0,0,1,2.72-.92A2,2,0,0,1,26.82,15.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52785",
    "data-name": "Group 52785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69027",
    "data-name": "Path 69027",
    className: "cls-6",
    d: "M24.7,30.62l-7.11,3.73a2,2,0,0,0,2.74.88h0l3.7-1.95a2,2,0,0,1,1.89,0l3.71,1.95a2,2,0,0,0,2.74-.85v0l-7.1-3.73a.64.64,0,0,0-.6,0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52789",
    "data-name": "Group 52789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52790",
    "data-name": "Group 52790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50669",
    "data-name": "Group 50669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50668",
    "data-name": "Group 50668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50667",
    "data-name": "Group 50667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67382",
    "data-name": "Path 67382",
    className: "cls-2",
    d: "M24,33.37A1.36,1.36,0,0,1,23,33a1.43,1.43,0,0,1-.41-1V23.31l-1.85,1.86a3.91,3.91,0,0,1-1.27.86,3.64,3.64,0,0,1-1.49.3,3.74,3.74,0,0,1-1.51-.3,3.59,3.59,0,0,1-1.25-.86l-1.87-1.88v8.64a1.41,1.41,0,0,1-.43,1,1.37,1.37,0,0,1-1,.42,1.39,1.39,0,0,1-1-.42,1.45,1.45,0,0,1-.42-1V19.84a1.45,1.45,0,0,1,.42-1,1.37,1.37,0,0,1,1-.42,1.43,1.43,0,0,1,.82.26v0l.18.17L17,23a1.33,1.33,0,0,0,.95.38A1.36,1.36,0,0,0,18.9,23l4.27-4.3h0A1.4,1.4,0,0,1,24,18.4a1.37,1.37,0,0,1,1,.42,1.45,1.45,0,0,1,.42,1V31.93A1.45,1.45,0,0,1,25,33,1.4,1.4,0,0,1,24,33.37Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_69028",
    "data-name": "Path 69028",
    className: "cls-2",
    d: "M39,25a1.15,1.15,0,0,0-.87-.67,1.21,1.21,0,0,0-1.07.37A1.16,1.16,0,0,0,36.9,26a3.46,3.46,0,0,1,.16,2.41,3.57,3.57,0,0,1-5.59,1.84,3.55,3.55,0,0,1-1.41-2.84,3.41,3.41,0,0,1,.27-1.34,1.19,1.19,0,0,0-.36-1.4,1.15,1.15,0,0,0-1.79.44,5.89,5.89,0,0,0-.48,2.3,5.92,5.92,0,0,0,5.94,6,5.29,5.29,0,0,0,1-.08,6,6,0,0,0,4.75-4.33A5.84,5.84,0,0,0,39,25Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50670",
    "data-name": "Group 50670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50669-2",
    "data-name": "Group 50669-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50668-2",
    "data-name": "Group 50668-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50667-2",
    "data-name": "Group 50667-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67382-2",
    "data-name": "Path 67382-2",
    className: "cls-7",
    d: "M24,32.4A1.37,1.37,0,0,1,23,32a1.4,1.4,0,0,1-.41-1V22.33l-1.85,1.86a4.1,4.1,0,0,1-1.27.87,3.81,3.81,0,0,1-1.49.3,3.91,3.91,0,0,1-1.51-.3,3.62,3.62,0,0,1-1.25-.87l-1.87-1.88V31a1.4,1.4,0,0,1-.43,1,1.37,1.37,0,0,1-1,.42,1.39,1.39,0,0,1-1-.42,1.43,1.43,0,0,1-.42-1V18.87a1.45,1.45,0,0,1,.42-1,1.4,1.4,0,0,1,1-.42,1.43,1.43,0,0,1,.82.26v0l.18.16L17,22a1.38,1.38,0,0,0,1.88,0l4.27-4.31h0a1.4,1.4,0,0,1,.82-.26,1.43,1.43,0,0,1,1.44,1.45V31A1.45,1.45,0,0,1,25,32,1.4,1.4,0,0,1,24,32.4Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52788",
    "data-name": "Group 52788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52792",
    "data-name": "Group 52792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67384-3",
    "data-name": "Path 67384-3",
    className: "cls-8",
    d: "M35.55,21.36a1,1,0,0,1,1,.93.92.92,0,0,1-.91,1h0a.93.93,0,0,1-1-.92v0A.94.94,0,0,1,35.55,21.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_69031-2",
    "data-name": "Path 69031-2",
    className: "cls-8",
    d: "M31.54,21.35a1,1,0,0,1,1,.94.93.93,0,0,1-.92.95h0a.93.93,0,0,1-1-.91v0A1,1,0,0,1,31.54,21.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67383",
    "data-name": "Path 67383",
    className: "cls-7",
    d: "M39,24a1.17,1.17,0,0,0-1.94-.29A1.16,1.16,0,0,0,36.9,25a3.45,3.45,0,0,1,.16,2.41,3.57,3.57,0,0,1-5.59,1.83,3.52,3.52,0,0,1-1.41-2.84,3.41,3.41,0,0,1,.27-1.34,1.19,1.19,0,0,0-.36-1.4,1.17,1.17,0,0,0-1.79.44,5.89,5.89,0,0,0-.48,2.3,5.94,5.94,0,0,0,5.94,6,6.35,6.35,0,0,0,1-.08A6,6,0,0,0,39.36,28,5.85,5.85,0,0,0,39,24Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50671",
    "data-name": "Group 50671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67384-4",
    "data-name": "Path 67384-4",
    className: "cls-9",
    d: "M35.55,21.06a1,1,0,0,1,1,.94.92.92,0,0,1-.91.95h0a.93.93,0,0,1-1-.91v0A1,1,0,0,1,35.55,21.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50672",
    "data-name": "Group 50672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67385-2",
    "data-name": "Path 67385-2",
    className: "cls-9",
    d: "M31.55,21.06a1,1,0,0,1,.95.94.93.93,0,0,1-.91.95h0a.93.93,0,0,1-1-.91.08.08,0,0,1,0,0A1,1,0,0,1,31.55,21.06Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Union_42",
    "data-name": "Union 42",
    className: "cls-4",
    d: "M7.91,43.42a1.5,1.5,0,0,0-.91-.9.72.72,0,0,1-.28-1A.63.63,0,0,1,7,41.27a1.48,1.48,0,0,0,.91-.9.71.71,0,0,1,1-.29.68.68,0,0,1,.29.29,1.54,1.54,0,0,0,.9.9h0a.71.71,0,0,1,.28,1,.63.63,0,0,1-.28.28,1.51,1.51,0,0,0-.9.9.71.71,0,0,1-1,.29A.68.68,0,0,1,7.91,43.42Zm-.56-1.53a2.17,2.17,0,0,1,1.19,1.19,2.11,2.11,0,0,1,1.19-1.19A2.05,2.05,0,0,1,8.54,40.7,2.11,2.11,0,0,1,7.35,41.89ZM4.1,41.28a4.4,4.4,0,0,0-2.57-2.57.71.71,0,0,1-.29-1,.81.81,0,0,1,.29-.29,4.4,4.4,0,0,0,2.56-2.56.69.69,0,0,1,.62-.38h0a.7.7,0,0,1,.63.37,4.39,4.39,0,0,0,2.58,2.57.71.71,0,0,1,.29,1,.58.58,0,0,1-.29.29,4.43,4.43,0,0,0-2.57,2.57.7.7,0,0,1-1,.29.68.68,0,0,1-.29-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_44",
    "data-name": "Union 44",
    className: "cls-4",
    d: "M45.07,12.46a1.59,1.59,0,0,0-.9-.9.71.71,0,0,1-.29-1,.61.61,0,0,1,.29-.28,1.54,1.54,0,0,0,.9-.9.7.7,0,0,1,1-.29.68.68,0,0,1,.29.29,1.49,1.49,0,0,0,.9.9h0a.7.7,0,0,1,0,1.25,1.54,1.54,0,0,0-.9.9.71.71,0,0,1-1,.29A.61.61,0,0,1,45.07,12.46Zm-3.81-2.14a4.42,4.42,0,0,0-2.58-2.57.72.72,0,0,1-.28-1,.71.71,0,0,1,.28-.29,4.34,4.34,0,0,0,2.56-2.56.73.73,0,0,1,.63-.38h0a.72.72,0,0,1,.63.37,4.39,4.39,0,0,0,2.58,2.57.73.73,0,0,1,.38.63h0a.71.71,0,0,1-.38.63,4.4,4.4,0,0,0-2.57,2.57.71.71,0,0,1-1,.29.81.81,0,0,1-.29-.29ZM39,7.12A5.07,5.07,0,0,1,41.88,10a5.09,5.09,0,0,1,2.86-2.86,5.08,5.08,0,0,1-2.87-2.86A5,5,0,0,1,39,7.12Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.48475fd530a4a86cf0b0532cd1090b08.svg";
export { ForwardRef as ReactComponent };